export default __webpack_public_path__ + "static/media/freedom_i.0ce49c13.png";